import { render, staticRenderFns } from "./BoxTabComponent.vue?vue&type=template&id=2b340d40&scoped=true&"
import script from "./BoxTabComponent.vue?vue&type=script&lang=ts&"
export * from "./BoxTabComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b340d40",
  null
  
)

export default component.exports